import React, { useEffect } from 'react'
import { Button } from 'antd';
import implement1 from '../../images/implement-1.jpg'
import implement2 from '../../images/implement-2.jpg'
import implement3 from '../../images/implement-3.jpg'
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import ImplementCard from './ImplementCard';


SwiperCore.use([Navigation]);

const swiperParams = {
    slidesPerView: 1.1,
    centeredSlides: false,
    loop: false,
    spaceBetween: 20,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    breakpoints: {
        900: {
            slidesPerView: 6.2,
        },
        600: {
            slidesPerView: 3.4,
        },
    },
}

// const { TabPane } = Tabs;

const viewAll = <Button type="primary" >View All</Button>;


function ImplementSection() {
    return (
        <div className="mt-16">
            <div className="p-4 m-4 rounded-lg shadow bg-white">
                <div className="">
                    <div className="p-2 flex justify-between border-b">
                        <h2 className="text-2xl font-bold text-gray-700">Popular Implements</h2>
                        {viewAll}
                    </div>
                    <div className="px-2">
                        <Swiper
                            {...swiperParams}
                            navigation={true}
                            // onSlideChange={() => console.log('slide change')}
                            // onSwiper={(swiper) => console.log(swiper)}
                            >
                            <SwiperSlide key="1">
                                <ImplementCard imageUrl={implement1} />
                            </SwiperSlide>

                            <SwiperSlide key="2">
                                <ImplementCard imageUrl={implement2} />
                            </SwiperSlide>
                            
                            <SwiperSlide key="3">
                                <ImplementCard imageUrl={implement3} />
                            </SwiperSlide>

                            <SwiperSlide key="4">
                                <ImplementCard imageUrl={implement1} />
                            </SwiperSlide>

                            <SwiperSlide key="5">
                                <ImplementCard imageUrl={implement2} />
                            </SwiperSlide>
                            
                            <SwiperSlide key="6">
                                <ImplementCard imageUrl={implement3} />
                            </SwiperSlide>

                            <SwiperSlide key="7">
                                <ImplementCard imageUrl={implement1} />
                            </SwiperSlide>

                            <SwiperSlide key="8">
                                <ImplementCard imageUrl={implement2} />
                            </SwiperSlide>
                            
                            <SwiperSlide key="9">
                                <ImplementCard imageUrl={implement3} />
                            </SwiperSlide>
                        </Swiper>
                    </div>
                    
                    
                </div>
            </div>
            
        </div>
    );
}

export default ImplementSection;
